<template>
  <!-- 单色柱状图图表 -->
  <div id="columecharts" ref="columecharts">
  </div>
</template>

<script>
export default {
  data(){
    return {

    }
  },
  props: ['echartdata'],
  mounted(){
    this.drawChart()
  },
  methods:{
      drawChart(){
        let _this = this;
        let coluchart = this.$echarts.init(this.$refs.columecharts);
        // let option = {
        //   grid: {
        //       top: '8%',
        //       left: '5%',
        //       right: '8%',
        //       bottom: '5%',
        //       containLabel: true
        //   },
        //   legend: {},
        //   tooltip: {},
        //   dataset: this.echartdata.columdata.data,
        //   xAxis: {type: 'category'},
        //   yAxis: {},
        //   series: [
        //       {type: 'bar'},
        //       {type: 'bar'},
        //       {type: 'bar'}
        //   ]
        // };
        let option = {
            // dataZoom: [
            //     {
            //         type: 'slider', //滑动条           
            //         show: true,      //开启            
            //         xAxisIndex: [0],            
            //         left: '93%',  //滑动条位置            
            //         start: 1,    //初始化时，滑动条宽度开始标度            
            //         end: 50      //初始化时，滑动条宽度结束标度       
            //     }
            // ],
            grid: {
                top: '5%',
                left: '5%',
                right: '8%',
                bottom: '5%',
                containLabel: true
            },
            color: ['#3398DB'],
            tooltip: {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            xAxis: [
                {
                    type: 'category',
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                    axisTick: {
                        alignWithLabel: true
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: '直接访问',
                    type: 'bar',
                    barWidth: '60%',
                    data: [10, 52, 200, 334, 390, 330, 220]
                }
            ]
        };

        // 绘制图表
        coluchart.setOption(option);
      }
  }

}
</script>

<style  lang="stylus" scoped>
#columecharts{
    height:500px;
}
</style>